var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"post-entertainment my-4"},[_c('div',{class:[
			'section-title',
			_vm.darkClass && 'title' in _vm.darkClass ? _vm.darkClass.title : '',
		]},[_c('h3',{class:`title text-${_vm.default_language.alignment}`},[_vm._v(_vm._s(_vm.category_news.title[_vm.default_language.code]))])]),_c('div',{staticClass:"row"},[_vm._l((_vm.category_news.news),function(news,index){return [_c('div',{key:index,staticClass:"col-lg-4 col-md-4"},[_c('trending-news-card',{class:[
						_vm.darkClass && 'item' in _vm.darkClass ? _vm.darkClass.item : '',
					],attrs:{"icon":false,"news":news}})],1)]})],2),_c('br'),_c('br'),_c('br')])
}
var staticRenderFns = []

export { render, staticRenderFns }